import { buildYup } from "schema-to-yup";
import Config from "@app/constants/Config";
import { FOLLOW_UP, INITIAL } from "@app/constants/Constants";
import getDisplayFields from "@app/lib/hooks/getDisplayFields";
import { filterFollowUp } from "@app/components/FormBuilder/FormBuilder";

export const DEPLOYMENT_STATE_KEYS = ["not_possible", "possible_with_measures", "not_suitable_for_mothers"];

// Platzhaltertexte für die Status-Badges (Ampel) — erscheinen bei Mouseover (Desktop)
// bzw. Tap (Mobile). Endgültiger Text folgt vom Kunden; hier erst einmal Provisorium,
// je State an einer Stelle austauschbar.
export const DEPLOYMENT_STATE_HINTS = {
	not_possible: "Ein Einsatz ist an diesem Arbeitsplatz nicht möglich, da ein Ausschlusskriterium vorliegt.",
	possible_with_measures: "Ein Einsatz ist erst nach Umsetzung der genannten Maßnahmen möglich.",
	not_suitable_for_mothers: "Der Arbeitsplatz ist für werdende oder stillende Mütter nicht geeignet.",
};

const validate = (values, schema) => {
	let errors = [];
	try {
		schema.validateSync(values, { abortEarly: false });
	} catch (e) {
		errors = e.inner.map(({ path, type, value, message }) => ({ path, type, value, message }));
	}
	return errors;
};

function filterByType(type, properties) {
	return Object.entries(properties).reduce(
		(acc, [key, value]) =>
			value[type]
				? {
						...acc,
						[key]: value[type],
					}
				: acc,
		{},
	);
}

export const validateStep = (values, fieldsets, type = INITIAL) => {
	const schemaProperties = fieldsets
		.map((fieldset) => ({
			...fieldset,
			elements: (fieldset.elements || []).filter((element) => filterFollowUp(type === FOLLOW_UP, element)),
		}))
		.reduce((acc, fieldset) => {
			const visibleElements = getDisplayFields(fieldset.elements, values);
			return fieldset?.elements?.[0]?.elementType === "followUp"
				? [...acc, ...getDisplayFields(fieldset.elements[0]?.formGroup.elements || [], values)]
				: [...acc, ...visibleElements];
		}, [])
		.filter((field) => field.validation?.extendedJsonValidation)
		.reduce((acc, field) => {
			return {
				...acc,
				[field.name]:
					typeof field.validation?.extendedJsonValidation === "object"
						? field.validation?.extendedJsonValidation
						: JSON.parse(field.validation?.extendedJsonValidation),
			};
		}, {});
	const schemaObject = {
		type: "object",
	};

	return DEPLOYMENT_STATE_KEYS.reduce(
		(acc, key) => ({
			...acc,
			[key]: validate(
				values,
				buildYup(
					{ ...schemaObject, properties: filterByType(key, schemaProperties) },
					{
						errMessages: {
							$required: Config.ERROR_DEFAULT_MESSAGE,
							$matches: Config.ERROR_MATCH_MESSAGE,
						},
					},
				),
			)?.reduce((acc, fieldRes) => {
				return acc[fieldRes.path]
					? acc
					: {
							...acc,
							[fieldRes.path]: { ...fieldRes, category: key },
						};
			}, {}),
		}),
		[],
	);
};

export function getDeploymentState(values, steps, type = INITIAL) {
	return steps.map((step) => validateStep(values, step.fieldsets, type));
}

export function mapDeploymentErrorCount(state) {
	return DEPLOYMENT_STATE_KEYS.reverse().reduce(
		(acc, key) => ({
			...acc,
			[key]: Object.entries(state[key])?.length,
		}),
		{},
	);
}
